var _line, _line2, _line3, _line4, _line5, _line6, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5977,
    y1: 14.0981,
    x2: 13.5977,
    y2: 2.09814,
    stroke: "#D91F05"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.6646,
    y1: 6.84814,
    x2: 13.6646,
    y2: 1.65199,
    stroke: "#D91F05"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16.6646,
    y1: 7.34814,
    x2: 13.6646,
    y2: 2.15199,
    stroke: "#D91F05"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 12,
    y2: -0.5,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 4 2)",
    stroke: "#D91F05"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 6,
    y2: -0.5,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 1 9)",
    stroke: "#D91F05"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 6,
    y2: -0.5,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 7 9)",
    stroke: "#D91F05"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 0.5,
    r: 0.5,
    fill: "#D91F05"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 15.5,
    r: 0.5,
    fill: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeSelect);
export default __webpack_public_path__ + "static/media/change_select.c23777e3ba73e06610f539db85c3ebc0.svg";
export { ForwardRef as ReactComponent };